<template>
  <div>
    <!-- 管理员设置 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>系统管理</el-breadcrumb-item>
      <el-breadcrumb-item>管理员设置</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="tab">
      <span
        v-for="(v,i) in navList"
        :key="v.id"
        @click="tabFn(i)"
        :class="activeTndex==i?'active':''"
      >{{v.name}}</span>
    </div>
    <!-- 管理员管理 -->
    <el-card v-if="activeTndex==0">
      <div class="titleBtn" >
        <el-button @click="addDetailFn('1')">
          <i class="iconfont icon-jiahao" >添加管理员</i>
        </el-button>
      </div>
      <div>
        <el-table
          :data="tableData"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          style="width: 100%"
        >
          <el-table-column prop="UserID" label="序号" width="180"></el-table-column>
          <el-table-column prop="UserName" label="用户名" width="180"></el-table-column>
          <el-table-column prop="role_name" label="所属角色"></el-table-column>
          <el-table-column prop="Login_ip" label="最后登录IP"></el-table-column>
          <el-table-column prop="Login_Time" label="最后登录时间"></el-table-column>
          <el-table-column prop="Phone" label="手机号"></el-table-column>
          <el-table-column prop="E_mail" label="Email"></el-table-column>
          <el-table-column prop="Name" label="真实姓名"></el-table-column>
          <el-table-column  label="操作"    fixed="right">
            <template slot-scope="scope">
              <el-popconfirm
                confirm-button-text='确认'
                cancel-button-text='取消'
                icon="el-icon-info"
                icon-color="red"
                title="是否删除"
                @confirm="confirms(scope.row)"
              >
                <div slot="reference" style="color:red;">
                  删除
                </div>
              </el-popconfirm>
              <el-button type="text" @click="addDetailFn(scope.row)">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <span class="demonstration">共{{total}}条记录，</span>
        <span class="demonstration">当前显示第{{data.page}}页</span>
        <el-pagination background layout="prev, pager, next" :page-size.sync="data.page_size"  :total="total"  @current-change="currenchange" ></el-pagination>
      </div>
      <!-- 分页开始 -->
      <!-- <div class="pagination">
        <span class="demonstration">共几条记录，</span>
        <span class="demonstration">当前显示第几页</span>
        <el-pagination background layout="prev, pager, next" :total="1000"></el-pagination>
      </div> -->
      <!-- 分页结束 -->
    </el-card>
    <!-- 角色管理 -->
    <el-card v-if="activeTndex==1">
      <div class="titleBtn">
        <el-button  @click="addRoleFn()">
          <i class="iconfont icon-jiahao">添加角色</i>
        </el-button>
      </div>
      <div>
        <el-table
          :data="tableData"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          style="width: 100%"
        >
          <el-table-column prop="id" label="序号" width="180"></el-table-column>
          <el-table-column prop="title" label="角色名称" width="180"></el-table-column>
          <el-table-column prop="description" label="角色描述"></el-table-column>
          <el-table-column prop="address" label="状态">
            <template slot-scope="scope">
              <img src="@/images/distributor/dh.png" alt v-if="scope.row.status=='0'"/>
              <img src="@/images/distributor/dl.png" alt v-else/>
              <span style="marginLeft:10px;">{{scope.row.status=='1'?'启用':'未启用'}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="操作"    fixed="right">
            <template slot-scope="scope">
              <!-- <el-button type="text" style="color: #FF4D4F;">删除</el-button> -->
              <el-popconfirm
                confirm-button-text='确认'
                cancel-button-text='取消'
                icon="el-icon-info"
                icon-color="red"
                title="是否删除"
                @confirm="conrole(scope.row)"
              >
                <div slot="reference" style="color:red;">
                  删除
                </div>
              </el-popconfirm>
              <el-button type="text" @click="rightSetFn(scope.row)">权限设置</el-button>
              <el-button type="text" @click="addRoleFn(scope.row)">修改</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <span class="demonstration">共{{total1}}条记录，</span>
        <span class="demonstration">当前显示第{{data1.page}}页</span>
        <el-pagination background layout="prev, pager, next" :page-size.sync="data1.page_size"  :total="total1"  @current-change="currenchange1" ></el-pagination>
      </div>
      <!-- 分页开始 -->
      <!-- <div class="pagination">
        <span class="demonstration">共几条记录，</span>
        <span class="demonstration">当前显示第几页</span>
        <el-pagination background layout="prev, pager, next" :total="1000"></el-pagination>
      </div> -->
      <!-- 分页结束 -->
    </el-card>
    <!-- 管理员添加详情开始 -->
    <personSetDialog v-if="addDefailvisible" ref="addDefailDialog" :ids="ids" @addclose="addInfoClose"></personSetDialog>
    <!-- 管理员添加详情结束 -->
    <!-- 管理员添加详情开始 -->
    <personSetDialog v-if="addRolevisible" ref="addRoleDialog" @roleClose="roleCloseInfo" :roleid="roleid"></personSetDialog>
    <!-- 管理员添加详情结束 -->
    <!-- 权限设置开始 -->
    <el-dialog :close-on-click-modal="false"
      title="角色权限"
      :visible.sync="rightDialogVisible"
      :before-close="rightHandleClose"
      width="54%"
      center
      class="autorDialog"
    >
      <el-divider></el-divider>

      <div class="rightSet">
        <div class="rightWorke">
          <div>
            <span>{{Name}}</span>
            <span>该角色用户拥有指定权限</span>
          </div>
          <div class="itemWorke" v-for="(item,index) in limits" :key="index">
            <div v-if="item.son">
              <div>{{item.title}}</div>
              <el-switch v-model="item.c" active-color="#246DEB" inactive-color="#E5E5EA" @change="switchCh(item,$event)"></el-switch>
            </div>
            <div v-if="item.son">
                <el-checkbox :label="v.id" v-model="v.c" v-for="v in item.son" :key="v.id" @change="CheckBox(item,$event)" >{{v.title}}</el-checkbox>
            </div>
          </div>
        </div>
      </div>
      <div class="itemRight" style="margin-left:-50px">
     
        <el-button class="btnL" @click="submitNode">确认添加</el-button>
      </div>
    </el-dialog>
    <!-- 权限设置结束 -->
  </div>
</template>

<script>
import personSetDialog from "./dialog/personSetDialog.vue";
import {
  getDistrbutorUserList,
  getDistrbutorUserDelete,
  getDistrbutorUserRoleList,
  deleteDistrbutorUserRole,
  getDistrbutorRoleNodeList,
  addDistrbutorRoleNode
} from '@/request/distributor.js'
import {Message} from 'element-ui'
export default {
  components: {
    personSetDialog
  },
  data() {
    return {
      ids:'',
      addDefailvisible: false, // 管理员添加和详情
      addRolevisible: false, // 角色添加和详情
      rightDialogVisible: false, // 权限设置
      navList: [
        {
          id: 1,
          name: "管理员管理"
        },
        {
          id: 2,
          name: "角色管理"
        }
      ],
      activeTndex: "",
      tableData: [
      ],
      // 工作台选项
      wordeData: [
        {
          id: 1,
          name: "短信剩余数量"
        },
        {
          id: 2,
          name: "审核短信模板"
        },
        {
          id: 3,
          name: "分销商审核"
        },
        {
          id: 4,
          name: "短信充值审核"
        },
        {
          id: 5,
          name: "App管理"
        },
        {
          id: 6,
          name: "产品列表"
        }
      ],
      value: "",
      checkedWorde: 1, // 工作台选中
      roleid:'',
      limits:[],
      role_id:'',
      Name:'',
      data:{
        token:window.sessionStorage.getItem('Token'),
        page:1,
        page_size:10
      },
      total:0,
      data1:{
        token:window.sessionStorage.getItem('Token'),
        page:1,
        page_size:10
      },
      total1:0
    };
  },
  created(){
    this.getList()
  },
  methods: {
    // 权限标题 二级选择
    CheckBox(item,e){
      if(e){
        item.c = true
      }else{
        console.log(e)
      }
      for(let i=0;i<item.son.length;i++){
        if(item.son[i].c){
          item.c = true
          this.$forceUpdate()
          return false
        }else{
          item.c = false
        }
      }
      this.$forceUpdate()
      this.$forceUpdate()
    },
    // 权限标题选择
    switchCh(item,e){
      if(e){
        if(item.son!=undefined){
          item.son.map(itm=>{
            itm.c = true
          })
        }
      }else{
        if(item.son!=undefined){
          item.son.map(itm=>{
            itm.c = false
          })
        }
      }
      this.$forceUpdate()
    },
    // 获取管理员列表
    getList(){
      getDistrbutorUserList(this.data).then(res=>{
        if(res.data.status=='ok'){
          this.tableData = res.data.result.data
          this.total = res.data.result.total
        }
      })
    },
    currenchange(e){
      this.data.page = e
      this.getList()
    },
    // 角色管理权限设置
    rightSetFn(row) {
      this.limits = []
      this.Name = row.title
      let data = {
        token:window.sessionStorage.getItem('Token')
      }
      getDistrbutorRoleNodeList(data).then(res=>{
          if(res.data.status=='ok'){
            this.limits = res.data.result
            if(row.rules!=''){
              row.rules.split(',').map(item=>{
                  this.limits.map(v=>{
                    if(v.id==item){
                      v.c = true
                    }
                    if(v.son!=undefined){
                      v.son.map(itm=>{
                        if(itm.id==item){
                          itm.c = true
                        }
                      })
                    }
                  })
                })
              }else{
            }
          }
      })
      this.role_id = row.id
      this.rightDialogVisible = true;
    },
    // 角色管理 确认授权
    submitNode(){
      var auth_id = ''
      this.limits.map(item=>{
        if(item.c==true){
          auth_id += item.id +',' 
        }
        if(item.son!=undefined){
          item.son.map(im=>{
            if(im.c==true){
              auth_id += im.id +',' 
            }
          })
        }
      })
      if (auth_id.length > 0) {
         auth_id = auth_id.substr(0, auth_id.length - 1);
      }
      if(auth_id==''){
        Message.error('请选择权限')
        return false
      }
      let data = {
        token:window.sessionStorage.getItem('Token'),
        role_id:this.role_id,
        node_id:auth_id
      }
      addDistrbutorRoleNode(data).then(res=>{
        if(res.data.status=='ok'){
          this.getRoleList()
          this.rightDialogVisible = false
          this.$message.success('授权成功')
        }else{
          Message.error(res.data.msg)
        }
      })
    },
    // 权限设置 关闭
    rightHandleClose(row) {
      this.rightDialogVisible = false;
    },
    // 打开添加角色和修改弹框
    addRoleFn(row) {
      if(row){
        this.roleid = row.id
      }else{
        this.roleid = ''
      }
      this.addRolevisible = true;
      this.$nextTick(() => {
        this.$refs.addRoleDialog.addRole(row);
      });
    },
    // 删除角色
    conrole(row){
      let data = {
        token:window.sessionStorage.getItem('Token'),
        id:row.id
      }
      deleteDistrbutorUserRole(data).then(res=>{
        if(res.data.status=='ok'){
          this.getRoleList()
          this.$message.success('删除成功')
        }else{
          this.$message.error(res.data.msg)
        }
      })
    },
    // 角色弹框关闭
    roleCloseInfo(){
      this.getRoleList()
      this.addRolevisible = false
    },
    // 添加管理员和详情
    addDetailFn(row) {
      if(row=='1'){
        this.ids = ''
      }else{
        this.ids = row.UserID
      }
      this.addDefailvisible = true;
      this.$nextTick(() => {
        this.$refs.addDefailDialog.addDefail(row);
      });
    },
    // 管理员删除
    confirms(row){
      let data = {
        token:window.sessionStorage.getItem('Token'),
        UserID:row.UserID
      }
      getDistrbutorUserDelete(data).then(res=>{
        if(res.data.status=='ok'){
          this.getList()
          this.$message.success('删除成功')
        }else{
          this.$message.error(res.data.msg)
        }
      })
    },
    // tab切换
    tabFn(i) {
      if(i=='0'){
        this.tableData = []
        this.data.page = 1
        this.total = 0
        this.getList()
      }else{  
        this.tableData = []
        this.data1.page = 1
        this.total1 = 0
        this.getRoleList()
      }
      this.activeTndex = i;
    },
    currenchange1(e){
      this.data1.page = e
      this.getRoleList()
    },
    // 角色列表
    getRoleList(){
      getDistrbutorUserRoleList(this.data1).then(res=>{
        if(res.data.status=='ok'){
          this.tableData = res.data.result.data
          this.total1 = res.data.result.total
        }
      })
    },
    // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    },
    // 管理员弹框关闭
    addInfoClose(){
      this.getList()
      this.addDefailvisible = false
    },
  }
};
</script>


<style lang='less' scoped>
.itemRight {
  display: flex;
  justify-content: center;
  margin-top: 40px;
  margin-bottom: 30px;
  /deep/.el-button {
    width: 100px;
    height: 40px;
    background: #d9d9d9;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
    border: none;
  }
  .btnL {
    width: 100px;
    height: 40px;
    background: #246deb;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
  }
}
.rightSet {
  .rightWorke {
    > div:nth-child(1) {
      margin-bottom: 7px;
      > span:nth-child(1) {
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
        /* identical to box height */
        text-align: center;
        color: #000000;
        margin-right: 10px;
      }
    }
    .itemWorke {
      margin-bottom: 17px;
      > div:nth-child(1) {
        display: flex;
        justify-content: space-between;
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
        /* identical to box height */
        color: #666666;
        margin-bottom: 5px;
      }
      > div:nth-child(2) {
        background: #ffffff;
        border: 1px solid #e5e5ea;
        border-radius: 4px;
        padding: 20px;
        // height: 94px;
        /deep/.el-checkbox__input.is-checked .el-checkbox__inner,
        .el-checkbox__input.is-indeterminate .el-checkbox__inner {
          background-color: #4ecb73;
          border-color: #4ecb73;
        }
        /deep/.el-checkbox__input.is-checked + .el-checkbox__label {
          font-family: ".PingFang SC";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          /* identical to box height */
          color: #666666;
        }
      }
    }
  }
}
.titleBtn {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
  .el-button {
    width: 135px;
    background: #ffffff;
    border: 1px solid #246deb;
    border-radius: 4px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #246deb;
  }
}
.tab {
  display: flex;
  margin: 20px 0;
  .active {
    background: #246deb;
  }
  span {
    cursor: pointer;
    width: 110px;
    height: 40px;
    display: block;
    background: #d9d9d9;
    border-radius: 4px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 40px;
    text-align: center;
    color: #ffffff;
    margin-right: 20px;
  }
}
// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 20px 0;
}
// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 45px auto 40px;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}

/deep/.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  color: #000000;
  background: #ffffff;
  border: 1px solid #e5e5ea;
  border-radius: 2px;
  min-width: 32px;
}
/deep/.el-pager li {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 0 4px;
  background: #fff;
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  box-sizing: border-box;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border: 1px solid #246deb;
  color: #246deb;
  background: white;
}

/deep/.el-pagination.is-background .btn-prev {
  color: #c0c4cc;
  height: 32px;
  min-width: 32px;
  background: white;
  border: 1px solid #e5e5ea;
}
/deep/.pagination .btn-prev .el-icon {
  display: block;
  font-size: 14px;
  font-weight: 700;
}

/deep/.el-pagination.is-background .btn-next {
  margin: 0 5px;
  background-color: white;
  color: #606266;
  min-width: 32px;
  height: 32px;
  border-radius: 2px;
  border: 1px solid #e5e5ea;
}
/deep/ .el-popover__reference{
  color: #66b1ff;
  cursor: pointer;
  margin-right: 10px;
}
/deep/.cell{
  display: flex;
  justify-content: center;
  align-items: center;
}
.rightSet{
  /deep/.el-checkbox__label{
    color: #666;
    font-size: 1.4rem;
  }

}
/deep/.el-dialog__close{
    color: #333 !important;
    font-size: 3rem;
}
/deep/.el-dialog__title{
color: #000;
font-family: OPPOSans;
font-size: 2rem;
}
</style>